// extracted by mini-css-extract-plugin
export default {"weekslist":"WeeksList_weekslist__gRAHq","weeks":"WeeksList_weeks__aeTID"};